import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useUserProfile } from '../hooks/useUserProfile';

/** Redirects orgs without `currencymodule` away from currency exposure routes. */
export default function RequireCurrencyModule({ children }) {
  const { user } = useAuth();
  const { loading, currencyModuleEnabled } = useUserProfile(user);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-12 text-gray-500 text-sm">
        Loading…
      </div>
    );
  }

  if (!currencyModuleEnabled) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
